import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=1253cbc4&"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports